<template>
    <div>

        <div class="inline-editor" style="width: 90vw; height: 600px"></div>
        <p><img class="inline-result" src="" alt="" /></p>

    </div>
</template>
<script>
require('../../doka/pintura.css')
import{
        setPlugins,
        plugin_crop,
        openDefaultEditor,
        createNode,
        appendEditor,
        createDefaultImageReader,
		createDefaultImageWriter
      } from "../../doka/pintura.js";
	  import locale_ru_RU from '../../doka/ru_RU/index.js';
      setPlugins(plugin_crop);
export default {
    name: "App",
    components: {
        
    },
    mounted() {
    this.startEditor()
  },
    methods: {
       startEditor(){
        this.editor = openDefaultEditor({
        src: this.photo,
		locale: locale_ru_RU,
		imageWriter: createDefaultImageWriter({
			store: {
                    url: '/api/photo.update',
                    dataset: (state) => [
                        ['file', state.dest, state.dest.name],
						['old', this.photoData.id],
						['_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content')],
                    ],
                    headers: {
						'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
					},
                },		
        }),
      });

       this.editor.on('process', (res) =>
       this.$emit('updateP')
                
            );
      

       }
    },
    props: ['photoData'],
    emits: ['updateP'],
    data() {
        return {
            editor: null,
            photo: this.photoData.url
        }
    }
}
</script>